import React from 'react';
import BudgetCalculator from './features/budgetCalculator/BudgetCalculator';
import 'semantic-ui-css/semantic.min.css';
import './App.scss';

const App: React.FC = () => {
  return <BudgetCalculator />;
};

export default App;